export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Voucher',
    path: '/voucher',
    icon: 'car'
  },
  {
    text: 'Service',
    path: '/service-voucher',
    icon: 'optionsgear'
  },
  {
    text: 'Messages',
    path: '/messages',
    icon: 'message'
  },
  {
    text: 'Contacts',
    path: '/contacts',
    icon: 'tel'
  },
];
